/* eslint-disable @typescript-eslint/camelcase */
import { QueryParamsEntities } from "@/domain/entities/MainApp";
import { UpdateHandoverRequestInterface } from "../contracts/HandoverRequest";
import { getHubData } from "@/app/infrastructures/misc/Cookies";

export class UpdateApiRequest implements UpdateHandoverRequestInterface {
  destinationPartnerId = 0;
  destinationPartnerCode = "";
  destinationPartnerType = "";
  destinationCityCode = "";
  remarks = "";
  handoverSttNo = [] as Array<string>;
  constructor(fields?: Partial<UpdateApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({
      destination_partner_id: this.destinationPartnerId,
      destination_partner_code: this.destinationPartnerCode,
      destination_partner_type: this.destinationPartnerType,
      destination_city_code: this.destinationCityCode,
      remarks: this.remarks,
      handover_stt_no: this.handoverSttNo,
      hub_id: getHubData()?.hubId || 0,
      hub_name: getHubData()?.hubName || "",
      hub_origin_city: getHubData()?.originCity || "",
      hub_district_code: getHubData()?.hubDistrictCode || ""
    });
  }
}

export class RequestListHandover {
  page = 1;
  limit = 10;
  search = "";
  sortBy = "";
  orderBy = "";
  startDate = "";
  endDate = "";
  destinationPartnerId = "";
  version = "v1";
  constructor(fields?: Partial<RequestListHandover>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class RequestPartnerVendorList {
  page = 1;
  limit = 10;
  search = "";
  constructor(fields?: Partial<RequestPartnerVendorList>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class RequestExportFileExcel {
  id = 0;
  version = "v1";
  constructor(fields?: Partial<RequestExportFileExcel>) {
    Object.assign(this, fields);
  }

  toIDString(): string {
    return this.id.toString();
  }

  toDateString(): string {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  }
}

export class RetryHandoverVendorRequest {
  sttNo = "";
  sttNos: string[] = [];

  constructor(fields?: Partial<RetryHandoverVendorRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    const list =
      this.sttNos && this.sttNos.length > 0
        ? this.sttNos
        : this.sttNo
        ? [this.sttNo]
        : [];

    if (list.length > 1) {
      return JSON.stringify({
        stt_nos: list
      });
    }

    return JSON.stringify({
      stt_no: list[0] || this.sttNo
    });
  }
}

export class RequestFailedVendorStt {
  page = 1;
  limit = 100;
  isTotalData = true;
  showOnlyFailed = false;

  constructor(fields?: Partial<RequestFailedVendorStt>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities({
      page: this.page,
      limit: this.limit,
      is_total_data: this.isTotalData
    }).queryString;
  }
}
